<div class="dialog-modal">
    <div class="dds-modal-init dds-modal-open">
        <div class="dds-modal-overlay"></div>
        <div class="dds-modal dds-modal_md relay-popup-container">
            <div class="dds-modal__header">
                <span class="dds-modal__title relay-popup-title">Welcome to Relay!</span>
                <button class="dds-modal__close dds-icon dds-icon_close" (click)="closeModal()"
                    aria-label="Close modal"></button>
            </div>
            <div class="dds-modal__body relay-popup-content">
              <p>Thank you for using Deloitte's Relay platform. This platform helps you initiate and track your submission for risk review, review submission progress, and archive final/executed version all in one place.</p>
                <p>Get started by clicking "Initiate new" to begin your first submission.</p>
            </div>
            <div class="dds-modal__footer">
                <div class="dds-modal__footer-content dds-modal__footer-content_left"></div>
                <div class="dds-modal__footer-content dds-modal__footer-content_right">
                    <div class="dds-modal__footer-item dds-inline-flex">
                        <button class="dds-btn dds-btn_fluid-width" (click)="closeModal()">
                            <div class="dds-btn__content">
                                <span class="dds-btn__text">OK</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div style="text-align: center; margin-top: 20px;display: none;">
    <button class="relay-popup-button" id="clearLocalStorageButton">Clear LocalStorage</button>
</div>
